import React, { useState } from 'react'
import { Stack, TextField, IconButton, useTheme, InputAdornment, Chip } from '@mui/material';
import Iconify from "./Iconify"

const MultiItemInput = ({ plusIconLeftPadding, inputValues, setInputValues, error, touched, required = false, inputLabel = "Default Prompt" }) => {
    const theme = useTheme()
    const [currentInput, setCurrentInput] = useState('');


    const handleInputChange = (e) => {
        setCurrentInput(e.target.value);
    };

    const handleAddItem = () => {
        if (currentInput.trim() !== '') {
            setInputValues([...inputValues, currentInput.trim()]);
            setCurrentInput('');
        }
    };

    const handleDeleteItem = (index) => {
        setInputValues(inputValues.filter((_, i) => i !== index));
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            handleAddItem();
        }
    };

    return (
        <>
            <TextField
                sx={{ marginBottom: "20px" }}
                required={required}
                autoComplete="false"
                size="small"
                id="outlined-basic-email"
                label={inputLabel}
                value={currentInput}
                error={touched && Boolean(error)}
                helperText={touched && error}
                onChange={handleInputChange}
                onKeyPress={handleKeyPress}
                fullWidth
                multiline
                minRows={1}
                maxRows={5}
                InputProps={{
                    endAdornment: (
                        <InputAdornment sx={{ paddingRight: plusIconLeftPadding || '0px' }} position="end">
                            <IconButton
                                onClick={handleAddItem}
                                size="medium"
                                type="button"
                                variant="contained"
                            >
                                <Iconify
                                    color={theme.palette.text.secondary}
                                    icon={'gg:add'}
                                    sx={{ fontSize: "16px" }}
                                />
                            </IconButton>
                        </InputAdornment>
                    ),
                }}
            />
            <Stack direction="row" sx={{ marginBottom: "6px", flexWrap: "wrap", gap: 1 }}>
                {inputValues.map((value, index) => (
                    <Chip
                        key={index}
                        label={value}
                        onDelete={() => handleDeleteItem(index)}
                        deleteIcon={<Iconify
                            color={theme.palette.text.secondary}
                            icon={'typcn:delete-outline'}
                        />}
                    />
                ))}
            </Stack>
        </>
    )
}

export default MultiItemInput